<template>
    <div class="technical-style">
      <full-page :options="options" ref="fullpage">
        <div class="section technical-top  " >
          <div >

            <div class="technical-nav ">
              <navbar classname="aboutus" childclassname="technical"></navbar>
            </div>
            <div class="section-content ">
              <div class="top-title">

                <div class="title-info">
                   
                 

                       <h1>成都北鸣</h1>
                 <span>CHENGDUBEIMING</span>
           <h2>旨在解决虚拟货币交易中的安全隐患</h2>
             <h2>高效 丨 安全 丨 智能 丨 便捷</h2>    
                </div>
                <!-- <div class="title-content">
             <img src="@/assets/image/newhome/businessintroduce/bannerbeijing.gif" alt="">
            </div> -->
          
              </div>
            </div>
          </div>
        </div>
     
      
       
        <div class="section technical-profession">
          <div class="profession-content animated-element1" v-show="isprofession">
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info  ">

                  <h1>技术能力</h1>
              <div class="technical-content">
            <div class="content-info">
              <img src="../../assets/image/newhome/technical/construction.png" alt="">
              <h1>分析团队</h1>
              <span>核心分析成员均来自火<br> 币、币安、OK等大型交易所</span>
            </div>
            <div class="content-info">
                <img src="../../assets/image/newhome/technical/secure.png" alt="">
         <h1>技术团队</h1>
         <span>技术开发成员均来自<br> 百度、华为等大厂</span>

            </div>
            <div class="content-info">
                <img src="../../assets/image/newhome/technical/Mapmodel.png" alt="">
                <h1>资产团队</h1>
                <span>合规资产团队<br>十亿级资产处理经验</span>
            </div>
  
 
  
   
              </div>
              
                </div>
       
            <!-- <div class="liucheng-button">
              <span>联系我们</span>
            </div> -->
              </div>
           
            </div>
       
          </div>
        </div>
        <div class="section technical-profession1">
          <div class="profession-content animated-element1" v-show="isprofession1">
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info  ">

                  <h1>专家级区块链安全方案供应商</h1>
                  <p>
                    运用融合AI、云计算、大数据、区块链技术的自研产品，聚合智能模型+AI识别模型+专家定向分析，打造行业顶尖专业团队提供服务支撑。数据驱动，独立自研，为用户提供全方位的高效精准打击及数据安全保障。
                  </p>
            
              
                </div>
       
            <!-- <div class="liucheng-button">
              <span>联系我们</span>
            </div> -->
              </div>
           
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
      </full-page>
      <div></div>
    </div>
  </template>
  <script>
  import navbar from "@/components/navbar.vue";
  import newfooter from "@/components/newfooter.vue";
  // import countTo  from 'vue-count-to';
  // import CountUp from "countup"
  export default {
    components: {
      navbar,
      newfooter,
      // countTo 
    },
    data() {
      return {
        // isshebi:false,
 
        isprofession:false,
        isprofession1:false,

        screenWidth: 0,
        bannerHeight: 0,
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          //是否显示导航，默认为false
          navigation: true,
   afterLoad: this.afterLoad,
   onLeave:this.onLeave,

          //为每个section设置背景色
          // sectionsColor: [
          //     "#41b883",
          //     "#ff5f45",
          //     "#0798ec",
          //     "#fec401",
          //     "#1bcee6",
          //     "#ee1a59",
          //     "#2c3e4f",
          //     "#ba5be9",
          //     "#b4b8ab"
          // ],
        },
      };
    },
    methods: {
    //   onLeave(index, direction){
    //   console.log(index, direction);
    // },
      afterLoad(anchorLink,index) {
        console.log(anchorLink,index);
          console.log("Emitted 'after load' event.")
          //获取body的classname，跟随section滑动刷新
          let a = document.body.className
          console.log(a);
          //在第几页控制相关逻辑
          if(a !== 'fp-scroll-mac fp-viewing-1' || a !== 'fp-viewing-1'){
            this.isprofession=false
          }
  
          if(a !== 'fp-scroll-mac fp-viewing-2' || a !== 'fp-viewing-2'){
            this.isprofession1=false
          }
          if (a === 'fp-scroll-mac fp-viewing-2' || a === 'fp-viewing-2') {
            // console.log(eee);
            this.isprofession1=true
     
        }
        else if(a === 'fp-scroll-mac fp-viewing-1' || a === 'fp-viewing-1'){
          this.isprofession=true
        }
        },
  
   
      next() {
        // 向下滚动一页
        this.$refs.fullpage.api.moveSectionUp();
// this.$refs.fullpage.goTo(0);
      },
    },
    // created(){     location.reload()},
    mounted() {
      this.next( )


      // 首次加载时,初始化高度
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (450 / 1450) * this.screenWidth;
      // 窗口大小发生改变
      window.onresize = () => {
        this.screenWidth = window.innerWidth;
        this.bannerHeight = (450 / 1450) * this.screenWidth;
      };
      
    },
  };
  </script>
  <style>
  .fp-warning,
  .fp-watermark {
    display: none !important;
  }
  </style>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/technical.scss";
  </style>
  